import React from 'react';
import "../template-file-css/document-file-template.css";


export const GHP_MARS = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='GHP_MARS' className='file-pdf-document'>
            <div className='file-template'>


                <h2>CURRENT MEDICATIONS AND TOTAL MG/DAY</h2>
                <table>
                    <tr>
                        <td className="w-50">
                            <span className='eleHeader text-center'>#</span>
                        </td>
                        <td className="w-500">
                            <span className="eleHeader text-center w-500;">Medication</span>
                        </td>
                        <td className="w-200">
                            <span className="eleHeader text-center w-200;">Total mg/Day</span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-50 text-center">
                            1
                        </td>
                        <td className="w-500 text-center">
                            <input type='text' id="txtMed_1" name="txtMed_1" className="add-only" />
                        </td>
                        <td className="w-200 text-center">
                            <input type='text' id="txtMedMg_1" name="txtMedMg_1" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-50 text-center">
                            2
                        </td>
                        <td className="w-500 text-center">
                            <input type='text' id="txtMed_2" name="txtMed_2" className="add-only" />
                        </td>
                        <td className="w-200 text-center">
                            <input type='text' id="txtMedMg_2" name="txtMedMg_2" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-50 text-center">
                            3
                        </td>
                        <td className="w-500 text-center">
                            <input type='text' id="txtMed_3" name="txtMed_3" className="add-only" />
                        </td>
                        <td className="w-200 text-center">
                            <input type='text' id="txtMedMg_3" name="txtMedMg_3" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-50 text-center">
                            4
                        </td>
                        <td className="w-500 text-center">
                            <input type='text' id="txtMed_4" name="txtMed_4" className="add-only" />
                        </td>
                        <td className="w-200 text-center">
                            <input type='text' id="txtMedMg_4" name="txtMedMg_4" className="add-only" />
                        </td>
                    </tr>
                </table>

                <h2>INSTRUCTIONS: COMPLETE THE EXAMINATION PROCEDURE BEFORE ENTERING THESE RATINGS.</h2>

                <table>
                    <tr>
                        <td className="w-550">
                            <span className='eleHeader'>Facial and Oral Movements</span>
                        </td>
                        <td className="w-100">
                            <span className='eleHeader text-center'>Yes</span>
                        </td>
                        <td className="w-100">
                            <span className='eleHeader text-center'>No</span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-550">
                            1. Do you ever forget to take your medication?
                        </td>
                        <td className="w-100 text-center">
                            <input type="radio" id="rb_1_1" name="rb_1" value="Y" className="add-only" />
                        </td>
                        <td className="w-100 text-center">
                            <input type="radio" id="rb_1_2" name="rb_1" value="N" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-550">
                            2. Are you careless at times at taking medication?
                        </td>
                        <td className="w-100 text-center">
                            <input type="radio" id="rb_2_1" name="rb_2" value="Y" className="add-only" />
                        </td>
                        <td className="w-100 text-center">
                            <input type="radio" id="rb_2_2" name="rb_2" value="N" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-550">
                            3. When you feel better do you sometimes stop taking your medication?
                        </td>
                        <td className="w-100 text-center">
                            <input type="radio" id="rb_3_1" name="rb_3" value="Y" className="add-only" />
                        </td>
                        <td className="w-100 text-center">
                            <input type="radio" id="rb_3_2" name="rb_3" value="N" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-550">
                            4. Sometimes if you feel worse when you take the medicine, do you stop taking it?
                        </td>
                        <td className="w-100 text-center">
                            <input type="radio" id="rb_4_1" name="rb_4" value="Y" className="add-only" />
                        </td>
                        <td className="w-100 text-center">
                            <input type="radio" id="rb_4_2" name="rb_4" value="N" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-550">
                            5. “I take my medication only when I am sick.”
                        </td>
                        <td className="w-100 text-center">
                            <input type="radio" id="rb_5_1" name="rb_5" value="Y" className="add-only" />
                        </td>
                        <td className="w-100 text-center">
                            <input type="radio" id="rb_5_2" name="rb_5" value="N" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-550">
                            6. “It is unnatural for my mind and body to be controlled by medication.”
                        </td>
                        <td className="w-100 text-center">
                            <input type="radio" id="rb_6_1" name="rb_6" value="Y" className="add-only" />
                        </td>
                        <td className="w-100 text-center">
                            <input type="radio" id="rb_6_2" name="rb_6" value="N" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-550">
                            7. “My thoughts are clearer on mediation.”
                        </td>
                        <td className="w-100 text-center">
                            <input type="radio" id="rb_7_1" name="rb_7" value="Y" className="add-only" />
                        </td>
                        <td className="w-100 text-center">
                            <input type="radio" id="rb_7_2" name="rb_7" value="N" className="add-only" />
                        </td>
                    </tr>
                    <tr className="background-color:#f2f2f2;">
                        <td className="w-550">
                            8. “By staying on my medication, I can prevent getting sick.”
                        </td>
                        <td className="w-100 text-center">
                            <input type="radio" id="rb_8_1" name="rb_8" value="Y" className="add-only" />
                        </td>
                        <td className="w-100 text-center">
                            <input type="radio" id="rb_8_2" name="rb_8" value="N" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-550">
                            9. “The medication makes me feel tired and sluggish.”
                        </td>
                        <td className="w-100 text-center">
                            <input type="radio" id="rb_9_1" name="rb_9" value="Y" className="add-only" />
                        </td>
                        <td className="w-100 text-center">
                            <input type="radio" id="rb_9_2" name="rb_9" value="N" className="add-only" />
                        </td>
                    </tr>
                </table>
                <span className="eleHeader">Complaint : “No” response for q 1-6, 9-10; “Yes” responses for q 7, 8</span>
                <textarea id="txtComplaint" name="txtComplaint" className="add-only "></textarea>

                <table>
                    <tr>
                        <td className="w-375">
                            <span className="eleHeader w-375;">Next Exam Date (Within 6 months)</span>
                            <input type='date' id="txtNextDate" name="txtNextDate" className="add-only" />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className="signature">&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="small">Examiner's Signature</td>
                    </tr>
                </table>
            </div>
        </form>
    )
}